<template>
  <div class="report-view task-time-sheet-report">
    <div class="viewEdit ttrInfo">
      <b-card class="d-flex">
        <div class="calendar justify-content-between mt-0">
          <p class="task-timesheet">
            ACL Attendance Abnormality Report
          </p>
          <div id="date-select" class="d-flex justify-content-center align-items-center mr-0 calender">
            <VueDatePicker :start="startDate" :end="endDate" :active-btn="activeBtn" @date="updateDate" />
          </div>
        </div>
      </b-card>
      <div class="card-filter-section mt-0">
        <b-row>
          <b-col cols="8" lg="8" class="d-block d-lg-flex align-items-center justify-content-start flex-wrap"> <button
              class="back-button btn btn-secondary mr-2" @click="back()">
              <feather-icon icon="ArrowLeftIcon" width="18" height="18" />
              <span>Back</span>
            </button>
            <p class="filter-title">
              Filters:
            </p>
            <div class="">
              <custom-dropdown v-model="is_active" :options="isActiveList" :search-box="false" :hide-close="true"
                label="Active" icon="EditIcon" />
            </div>
            <div>
              <custom-dropdown v-model="searchUser" :options="filterUserOptions" multiple label="Members"
                icon="EditIcon" />
            </div>
            <div>
              <custom-dropdown v-model="abnormalityType" :options="abnormalityTypeOptions" multiple label="Type"
                icon="EditIcon" />
            </div>
            <option-drop-down v-model="perPage" />
          </b-col>
          <b-col cols="4" lg="4" class="d-flex justify-content-end">
            <button class="apply-filter filterRedesign mr-1" @click="applyFilter()">
              Apply Filter
            </button>
            <button class="apply-filter-clear filterRedesign mr-1" @click="clearFilter()">
              Clear
            </button>
          </b-col>
        </b-row>
      </div>
      <div class="report-task-section">
        <list-loader v-if="loader && reports.length == 0" :fields="tableFields" />
        <div v-else-if="reports.length">
          <div class="emp-list time-sheet-list tableDesigns">
            <b-table :items="reports" :fields="tableFields" show-empty responsive
              class="emp-list-data emp-list-report table-responsive time-sheet-report">
              <template #cell(employee_id)="data">
                <div>
                  <p class="date">
                    {{ data.item.employee_id || (data.item.user ? data.item.user.emp_id : '-') }}                   
                  </p>
                </div>
              </template>
              <template #cell(employee_name)="data">
                <div class="d-flex align-items-center new-time-report">
                  <b-avatar v-if="data.item.employee_name || data.item.user" 
                    size="30" 
                    :text="(data.item.employee_name || (data.item.user ? data.item.user.name + ' ' + (data.item.user.last_name || '') : '')).split(' ')[0] | avatarText"  
                    style="background-color: #f97753" />
                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.employee_name || (data.item.user ? data.item.user.name + ' ' + (data.item.user.last_name || '') : '-') }}
                    </p>
                  </div>
                </div>
              </template>
              <template #cell(reporting_to)="data">
                <div class="d-flex align-items-center new-time-report">
                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.reporting_to && data.item.reporting_to.name ? data.item.reporting_to.name + ' ' + (data.item.reporting_to.last_name || '') : '-' }}
                    </p>
                  </div>
                </div>
              </template>
              <template #cell(manage_by)="data">
                <div class="d-flex align-items-center new-time-report">
                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.manage_by && data.item.manage_by.name ? data.item.manage_by.name + ' ' + (data.item.manage_by.last_name || '') : '-' }}
                    </p>
                  </div>
                </div>
              </template>
              <template #cell(date)="data">
                <div>
                  <p v-if="data.item.date" class="date">
                    {{ data.item.date | timeDayFormat }}
                  </p>
                  <span v-else>-</span>
                </div>
              </template>
              <template #cell(type)="data">
                <div>
                  <span class="badge" :class="getAbnormalityTypeClass(data.item.type)">
                    {{ getAbnormalityTypeLabel(data.item.type) }}
                  </span>
                </div>
              </template>
              <template #cell(punch_time)="data">
                <div>
                  <span v-if="data.item.punch_time" class="date">
                    {{ data.item.punch_time | fullTimeFormat }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </div>
              </template>
            </b-table>
            <Pagination v-if="totalCount > 0" :current-page="currentPage" :per-page="perPage" :total-count="totalCount"
              class="report-pagination" @currentPage="currentPage = $event" />
          </div>
        </div>
        <div v-else class="w-100">
          <img src="@/assets/images/nodatafound/nodata.svg" alt="no-data" class="no-data-img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AclAttendanceAbnormalityReportMixin from '../../mixin/report/AclAttendanceAbnormalityReport/index'
import ListLoader from '@/components/loaders/table-loading.vue'
import customDropdown from '@/components/dropdown/customDropdown.vue'
import VueDatePicker from '../../views/TaskSummary/calender.vue'

export default {
  name: 'AclAttendanceAbnormalityReport',
  components: {
    ListLoader,
    customDropdown,
    VueDatePicker,
  },
  mixins: [AclAttendanceAbnormalityReportMixin],
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/component-css/approvals.css";
@import "../../assets/scss/component-css/report.css";
@import "../../assets/scss/variables/_variables.scss";
@import "../../assets/scss/component-css/clockTimesheetReport.scss";
@import "../../assets/scss/component-css/aclAttendanceAbnormalityReport.scss";
</style>
